import React from 'react'
import Navbar from '../navbar/navbar'
import Designs from '../design/designs'


const Contactpage = () => {
  return (
    <div>
      <Navbar/>
      <Designs/>
    </div>
  )
}

export default Contactpage
